



























































import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import UiFileInputComponent from "@components/ui/input/ui-file-input.vue";
import CropImagePreviewComponent from "@components/cropImage/crop-image-preview.vue";
import ImagePreviewModel from "crop-image/src/ImagePreviewModel";

//import ImagePreview from "@models/imagePreview";

@Component({
  name: "ui-image-croper"
})
export default class UiImageCroperComponent extends Vue {
  cropImageUrl = "";
  file: File;
  cropFile: File;
  errorMessage: string = "";
  hasError: boolean = false;
   
  @Prop({ default: () =>  new ImagePreviewModel() }) value: ImagePreviewModel;
  innervalue: ImagePreviewModel = this.value;
  @Watch("innervalue")
  onInnerValueChanged() {
    this.$emit('input', this.innervalue);
  }
  @Watch("value")
  onValueChanged() {
    this.innervalue = this.value;
  }
  @Prop({ default: true })
  showError!: boolean;
  @Prop({ default: true })
  required!: boolean;
  @Prop({default:1})
  aspectRatio:number;
  startChooseFile() {
    (this.$refs.fileInput as UiFileInputComponent).onClick();
  }
  removeImage(){
    this.clearFile;
    const newData = new ImagePreviewModel();
    newData.ImageUrl = '';
    newData.Width = 0;
    newData.Height = 0;
    newData.Top = 0;
    newData.Left = 0;
    Object.assign(this.innervalue, newData);
  }
  setPositions(data: any) {
    this.innervalue = new ImagePreviewModel();
    this.innervalue.Width=data.width;
    this.innervalue.Height=data.height;
    this.innervalue.Top=data.top;
    this.innervalue.Left=data.left;
  }
  onCropUpdate(data: ImagePreviewModel) {
    this.setPositions(data);     
  }
  onLoadFile(file: File) {
    this.cropFile = file;
    var fileToLoad = file;
    var fileReader = new FileReader();

    fileReader.onload = (fileLoadedEvent: any) => {
      var srcData = fileLoadedEvent.target.result;
      this.cropImageUrl = srcData;
    };
    fileReader.readAsDataURL(fileToLoad);
  }
  saveCrop() {   
    
    this.file = this.cropFile;
    this.cropFile = null;
    (this.$refs.crop as any).forceUpdate();
    this.innervalue.ImageUrl = this.cropImageUrl;
    this.cropImageUrl = null;
    this.clearFile();
    this.isValid();  
  }

  getSetParams()
  {
    return this.innervalue;
  }

  isValid(): boolean {
    this.errorMessage = "";
    if (this.required && (!this.innervalue.ImageUrl || this.innervalue.ImageUrl == '/assets/img/no_image.svg')) {
      this.errorMessage = "*Выберите изображение";
      this.hasError = true;
      return false;
    }
    this.hasError = false;
    return true;
  }
  

  

  getFile() {
    return this.innervalue;
  }

  clearFile() {
    this.cropImageUrl = null;
    (this.$refs.fileInput as UiFileInputComponent).setFile(this.file);
  }
}
